import api from '../utils/api';

const BASE = '/api/comments';

/**
 * Fetch paginated comments for a resource, sorted newest-first.
 * Auth is optional — when signed in, each comment includes an `isLiked` flag.
 * @route GET /api/comments/origin/:originId
 * @param {string} originId - ObjectId of the Scenario, Situation, Classroom, or Assignment
 * @param {number} [page=1]
 * @param {number} [limit=10]
 * @returns {Promise<Object[]>} Comments with sender populated and `isLiked` boolean
 */
export const getComments = (originId, page, limit) =>
    api.get(`${BASE}/origin/${originId}`, { params: { page, limit } }).then((r) => r.data);

/**
 * Post a comment on a resource.
 * @route POST /api/comments
 * @param {string} originId - ObjectId of the resource being commented on
 * @param {string} message
 * @param {'Scenario'|'Situation'|'Classroom'|'Assignment'} onModel - discriminator for the polymorphic origin ref
 * @returns {Promise<Object>} The created comment with sender populated
 */
export const createComment = (originId, message, onModel) =>
    api.post(BASE, { message, origin: originId, onModel }).then((r) => r.data);

/**
 * Toggle a like on a comment. Returns `{liked: true}` (201) when added, `{liked: false}` (200) when removed.
 * @route POST /api/comments/:commentId/like
 * @param {string} commentId
 * @returns {Promise<{liked: boolean}>}
 */
export const toggleLikeComment = (commentId) =>
    api.post(`${BASE}/${commentId}/like`).then((r) => r.data);

/**
 * Edit a comment. Only the original sender may do this.
 * @route PATCH /api/comments/:commentId
 * @param {string} commentId
 * @param {string} message
 * @returns {Promise<Object>} The updated comment
 */
export const updateComment = (commentId, message) =>
    api.patch(`${BASE}/${commentId}`, { message }).then((r) => r.data);

/**
 * Delete a comment (also removes its likes and decrements the origin's commentsCount).
 * Only the original sender may do this.
 * @route DELETE /api/comments/:commentId
 * @param {string} commentId
 * @returns {Promise<{message: string}>}
 */
export const deleteComment = (commentId) =>
    api.delete(`${BASE}/${commentId}`).then((r) => r.data);
